import axios from "axios";

const state = {
  settings: [],
};

const getters = {
  settings(state) {
    return state.settings;
  },
};

const mutations = {
  setSettings(state, settings) {
    state.settings = settings;
  },
};

const actions = {
  async fetchSettings({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/setting/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setSettings", res.data);
      });
  },

  async updateSetting({ rootState }, data) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    return await axios.post(`${apiUrl}/setting/update/${data.id}`, data.setting, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
